class ProductFixedBar extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.timeout = null
    this.delay = 4200
  }

  connectedCallback () {
    super.connectedCallback()

    if (!this.externalEls?.form?.exists) return

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      rootMargin: '0px',
      threshold: 0,
    })

    this.observer.observe(this.externalEls.form.element)

    if (!this.externalEls?.footer?.exists) return

    this.observer.observe(this.externalEls.footer.element)
  }

  setupListeners () {
    super.setupListeners()

    if (this.dataset.updateFormStatus === 'true') {
      const formClasses = {
        loading:
          this.dataset.loadingClass !== undefined
            ? this.dataset.loadingClass
            : 'loading',
        added:
          this.dataset.addedClass !== undefined
            ? this.dataset.addedClass
            : 'added',
      }

      window.BAO.eventBus.addEventListener(
        window.BAO.EVENTS.PUSH_CART.BEFORE_ADD_FROM_FORM,
        () => {
          this.classList.add(formClasses.loading)
          this.ariaBusy = 'true'
          this.classList.remove(formClasses.added)
        },
      )

      window.BAO.eventBus.addEventListener(
        window.BAO.EVENTS.PUSH_CART.AFTER_ADD_FROM_FORM,
        () => {
          this.classList.remove(formClasses.loading)
          this.ariaBusy = 'false'
          this.classList.add(formClasses.added)

          this.timeout = null
          this.timeout = setTimeout(() => {
            this.classList.remove(formClasses.added)
          }, this.delay)
        },
      )

      window.BAO.eventBus.addEventListener(window.BAO.EVENTS.CART.ERROR, () => {
        this.classList.remove(formClasses.loading)
        this.ariaBusy = 'false'
        this.classList.remove(formClasses.added)
      })
    }
  }

  onEntry ([entry], observer) {
    this.setAttribute('aria-hidden', entry.isIntersecting)
  }
}

if (!customElements.get('product-fixed-bar')) {
  customElements.define('product-fixed-bar', ProductFixedBar)
}
